import {
  USER_NOTIFICATIONS_MODAL_LIST,
  USER_NOTIFICATIONS_MODAL_LIST_SUCCESS,
  USER_NOTIFICATIONS_MODAL_LIST_ERROR,
} from "./actionTypes"


export const userNotificationsModalList = data => ({
  type: USER_NOTIFICATIONS_MODAL_LIST,
  payload: data
});

export const userNotificationsModalListSuccess = data => ({
  type: USER_NOTIFICATIONS_MODAL_LIST_SUCCESS,
  payload: {data}
});

export const userNotificationsModalListError = error => ({
  type: USER_NOTIFICATIONS_MODAL_LIST_ERROR,
  payload: error,
});
